import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import GetValidityChip from "./GetValidityChip";
import SignerList from "./SignerList";
import { Button } from "@mui/material";
import dayjs from "dayjs";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { NOTIFICATION_UNITS } from "../../constants/notificationUnit";

export default function AgreementShowInfo({
  agreement,
  signers,
  hideInfo = false,
}) {
  return (
    <Grid container direction="row">
      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Estado:
          </Typography>
           <GetValidityChip status={agreement.status} />
        </Box>
      </Grid>
      <Grid item xs={6}>
        {!hideInfo && (
          <Box display="flex" alignItems="center" gap={1}>
            <Typography
              variant="subtitle1"
              component="span"
              sx={{ fontWeight: "bold" }}
            >
              Creado por:
            </Typography>
            {agreement?.user.name}
          </Box>
        )}
      </Grid>
      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Nº de orden:
          </Typography>
          {agreement.order_number}
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Tipo de convenio:
          </Typography>
          {agreement.agreement_type}
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Objetivo:
          </Typography>
          {agreement.objective}
        </Box>
      </Grid>

      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Institución Co-celebrante:
          </Typography>
          {agreement.entity}
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Nº de resolución:
          </Typography>
          {agreement.resolution_number}
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Fecha de suscripción:
          </Typography>
          {agreement.suscription_date
            ? dayjs(agreement.suscription_date).format("DD/MM/YYYY")
            : "Sin fecha"}
        </Box>
      </Grid>

      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Fecha de vigencia:
          </Typography>
          {dayjs(agreement.effective_date).format("DD/MM/YYYY")}
        </Box>
      </Grid>
      {!hideInfo && (
        <>
          <Grid item xs={6}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography
                variant="subtitle1"
                component="span"
                sx={{ fontWeight: "bold" }}
              >
                Notificar antes de:
              </Typography>
              {agreement.notification_amount}{" "}
              {NOTIFICATION_UNITS[agreement.notification_unit]}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography
                variant="subtitle1"
                component="span"
                sx={{ fontWeight: "bold" }}
              >
                Correo del proponente:
              </Typography>
              {agreement.proponent_email}
            </Box>
          </Grid>{" "}
        </>
      )}
      <Grid item xs={12} sx={{ mt: 2 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="subtitle1"
            component="span"
            sx={{ fontWeight: "bold" }}
          >
            Firmantes:
          </Typography>
          <SignerList signers={signers} />
        </Box>
      </Grid>

      <Grid item xs={12} sx={{ mt: 4 }}>
        <Typography
          variant="subtitle1"
          component="span"
          sx={{ fontWeight: "bold" }}
        >
          Archivos adjuntados:
        </Typography>

        {agreement.images && (
          <Box
            sx={{
              width: "100%",
              overflowX: "auto",
              maxWidth: "100%",
              border: "1px solid #ccc",
              borderRadius: 2,
              padding: 2,
            }}
          >
            <DocViewer
              documents={agreement.images}
              pluginRenderers={DocViewerRenderers}
              style={{ height: 500, width: "100%" }}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  );
}
